<template>
    <section
        id="aboutus"
        class="grey lighten-3"
      >
        <div class="py-12"></div>

        <v-container class="text-center">
          <h2 class="display-2 font-weight-bold mb-3">About Us</h2>

          <v-responsive
            class="mx-auto mb-12"
            width="56"
          >
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <v-row>
            <v-col
              v-for="({ icon, title, text }, i) in features"
              :key="i"
              cols="12"
              md="12"
            >
              <v-card class="ma-8" color="grey lighten-5" elevation=8 >
                <v-theme-provider dark>
                  <div>
                    <v-avatar class="elevation-12 mb-4 mt-12" size="128" >
                      <v-img :src="icon"></v-img>
                    </v-avatar>
                  </div>
                </v-theme-provider>

                <v-card-title class="justify-center font-weight-black text-uppercase" v-text="title" ></v-card-title>
                <v-card-text class="subtitle-1" v-html="text" ></v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>

        <div class="py-12"></div>
      </section>
</template>


<script>
  export default {
    name: 'AboutUs',

    data: () => ({
      content_loaded:false,
      features: [],
    }),
    methods: {
        loadBio(idx, filename) {
            this.$http
                .get(this.getHost() + 'content/' + filename)
                .then(function(data) {
                    this.features[idx]['text'] = data.body;
                });
      }

    },
    mounted(){
        if (!this.content_loaded) {
            this.$http
                .get(this.getHost() + 'content/bios.json')
                .then(function(data) {
                    let bios = data.body;
                    let host = this.getHost();
                    this.features = [];
                    for (let i in bios) {
                        this.features.push({
                            title: bios[i]['title'],
                            icon: host + "content/" + bios[i]["icon"],
                            text: "Loading..."
                            });
                        this.loadBio(i, bios[i]["bio"]);
                    }
                });
            this.content_loaded = true;
        }
        },
  }
</script>
